import { getRequest } from '../services/requestHandler';
import { ShaftByShaftNameForDropdown } from '../models';
import { HeadTypeDescription } from '../models/TourBagMstrPayload';

export const getShaftByShaftNameForDropdown = async (shaftType?: HeadTypeDescription | HeadTypeDescription[]) => {
  // TODO: Fix for Metals
  let shaftTypeFilter = 'Driver%2CFairway'; // default value Driver & Fairway to support Metals
  if (shaftType) {
    shaftTypeFilter = Array.isArray(shaftType) ? shaftType.join('%2') : shaftType;
  }
  const url = `vaultsync/GetShaftsByShaftNameFilterSpForDropdown?filter=&shaftType=${shaftTypeFilter}&shaftManufacturer=&shaftFlex=&isApprovedOnly=true&checkFilterForMfr=true`;
  const response = await getRequest<ShaftByShaftNameForDropdown>('GetShaftsByName', url);
  return response;
};
